<ng-container *transloco="let t">
  <mat-form-field [formGroup]="autocompleteForm" class="input-autocomplete"
                  [subscriptSizing]="subscriptSizing"
                  [class.disabled]="disabled1">
    <input [matAutocomplete]="auto" matInput ngDefaultControl [readonly]="disabled1" formControlName="input"
           placeholder="{{ t(formInputPlaceholderKey) }}" [multiple]="multiselect()" [errorStateMatcher]="errorStateMatcher">
    <div class="mat-mdc-select-arrow-wrapper ng-tns-c1154042729-3">
        <div class="mat-mdc-select-arrow ng-tns-c1154042729-3">
            <mat-icon svgIcon="arrow-down-dark"></mat-icon>
        </div>
    </div>
    <mat-autocomplete #auto="matAutocomplete" (optionSelected)="onOptionSelected($event)" [displayWith]="displayFn">
      <mat-option *ngIf="showEmptyOption()" value=''></mat-option>
      @for (option of options | async; track option.id) {
        <mat-option [value]="option">{{ option.name }}</mat-option>
      }
    </mat-autocomplete>
  </mat-form-field>
</ng-container>
